import React, { useState } from 'react';
import { Paper, Typography, alpha } from '@mui/material';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { CenteredFlexBox } from '../../../Components/FlexBox';
import AddStageStep from './AddStageStep';
import IconButton from '../../../Components/Button/IconButton';
import ConfirmDialog from '../../../Components/Dialog/ConfirmDialog';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';

const StageStep = function StageStep({
  id,
  isFirst,
  isLast,
  value,
  lowerValue,
  title,
  description,
  color,
  onDelete,
  isSystem,
  onEdit,
}) {
  const [edit, setEdit] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleSetEdit = () => {
    setEdit(true);
  };

  const handleCancelEdit = () => {
    setEdit(false);
  };

  const handleOpenConfirmDelete = () => {
    setConfirmDelete(true);
  };
  const handleCloseConfirmDelete = () => {
    setConfirmDelete(false);
  };

  const handleEdit = (data) => {
    onEdit({
      id,
      name: data.name,
      advancementThreshold: data.advancementThreshold,
      description: data.description,
    });
    setEdit(false);
  };

  return edit ? (
    <AddStageStep
      onSave={handleEdit}
      defaultValue={{ name: title, value, description }}
      isSystem={isSystem}
      cancelEdit={handleCancelEdit}
    />
  ) : (
    <>
      <Paper
        variant="outlined"
        sx={{
          padding: '16px',
          backgroundColor: alpha(color, 0.4),
          border: `2px solid ${color}`,
        }}
      >
        <CenteredFlexBox gap="16px">
          <CenteredFlexBox
            justifyContent="center"
            sx={{
              backgroundColor: '#fff',
              color,
              minWidth: '60px',
              borderRadius: '50px',
              padding: '4px 8px',
            }}
          >
            <Typography color={color} variant="h6">
              {isFirst ? `0%` : isLast ? '100%' : `${lowerValue}% - ${value}%`}
            </Typography>
          </CenteredFlexBox>
          <CenteredFlexBox gap="6px" flexGrow={1}>
            <Typography variant="h6">{title}</Typography>
            {description && (
              <IconButton
                id="stage-description-help"
                size="small"
                title={description}
                tooltipProps={{
                  placement: 'top',
                  arrow: true,
                  componentsProps: {
                    tooltip: {
                      sx: {
                        padding: '8px',
                        fontSize: '1.2rem',
                      },
                    },
                  },
                }}
              >
                <HelpOutlineRoundedIcon />
              </IconButton>
            )}
          </CenteredFlexBox>
          <CenteredFlexBox>
            <IconButton
              id="edit-icnBtn"
              title="EDIT"
              size="large"
              onClick={handleSetEdit}
            >
              <EditRoundedIcon sx={{ color: 'inherit' }} />
            </IconButton>
            {onDelete && (
              <IconButton
                id="delete-icnBtn"
                title="DELETE"
                size="large"
                disabled={isSystem}
                onClick={handleOpenConfirmDelete}
              >
                <DeleteRoundedIcon sx={{ color: 'inherit' }} />
              </IconButton>
            )}
          </CenteredFlexBox>
        </CenteredFlexBox>
      </Paper>
      <ConfirmDialog
        open={confirmDelete}
        onClose={handleCloseConfirmDelete}
        fontSize="1.5rem"
        title="CONFIRM_DELETE"
        question="CONFIRM_DELETE_STAGE_STEP"
        onCancel={handleCloseConfirmDelete}
        onSubmit={() => {
          onDelete(id);
          handleCloseConfirmDelete();
        }}
      />
    </>
  );
};

export default StageStep;
